import { createSlice } from "@reduxjs/toolkit";
import { CONSTANTS } from "common";
import organizationModel, { ModelType, SelectedOrganizationType } from 'model/organizationModel';

const initialState: organizationModel = {
    id: 0,
    name: "",
    listOfModels: [],
    organizations: [],
    selectedOrganization: null,
    isOrganizationInitialized: false,
}

export const messageSlice = createSlice({
    name: "organization",
    initialState,
    reducers: {
        addOrganization: (state, action) => {
            state.id = action.payload.id;
            state.name = action.payload.name;
        },
        saveBpmnDiagram: (state, action) => {
            // state.bpmn = action.payload.bpmn
        },
        addProcessModel: (state, action) => {
            const { newModel } = action.payload
            const updatedList = [...state.listOfModels]
            updatedList.push(newModel)
            state.listOfModels = [...updatedList]
        },
        updateProcessModel: (state, action) => {

            const { updatedModel } = action.payload

            const updatedList = [...state.listOfModels]

            const index = updatedList.findIndex((model: ModelType) => {
                return model.id === updatedModel.id
            })

            updatedList.splice(index, 1, updatedModel)

            state.listOfModels = [...updatedList]
        },
        deleteProcessModel: (state, action) => {
            const { index, id } = action.payload
            const updatedModels = [...state.listOfModels]

            if (updatedModels[index].id === id) {
                updatedModels.splice(index, 1)
            }
            state.listOfModels = [...updatedModels]
        },
        addOrganizations: (state, action) => {
            const { list } = action.payload;
            state.organizations = list;

            // Ripristina dal localStorage SOLO se non ancora inizializzato e abbiamo una lista
            if (!state.isOrganizationInitialized && list && list.length > 0) {
                const savedId = localStorage.getItem(CONSTANTS.STORE_SELECTED_ORGANIZATION_ID);
                let organization = null;

                if (savedId) {
                    organization = list.find(
                        (org: SelectedOrganizationType) => String(org.id) === String(savedId)
                    );
                }

                // Fallback alla prima se non trovato nel localStorage o se localStorage è vuoto
                if (!organization) {
                    organization = list[0];
                }

                if (organization) {
                    state.selectedOrganization = organization;
                    // Opzionalmente salviamo nel localStorage se non c'era nulla
                    if (!savedId && organization.id) {
                        localStorage.setItem(CONSTANTS.STORE_SELECTED_ORGANIZATION_ID, String(organization.id));
                    }
                }
                state.isOrganizationInitialized = true;
            }
        },
        addSelectedOrganization: (state, action) => {
            const { id } = action.payload;
            if (id === null || id === undefined) {
                state.selectedOrganization = null;
                localStorage.removeItem(CONSTANTS.STORE_SELECTED_ORGANIZATION_ID);
                return;
            }
            const organization = state.organizations.find(org => String(org.id) === String(id));
            if (organization) {
                state.selectedOrganization = organization;
                localStorage.setItem(CONSTANTS.STORE_SELECTED_ORGANIZATION_ID, String(id));
                // Se l'utente seleziona manualmente, consideriamo lo stato inizializzato
                state.isOrganizationInitialized = true;
            }
        },
        selectDefaultOrganization: (state, action) => {
            const organizationsList: Array<SelectedOrganizationType> = [...state.organizations];
            if (organizationsList.length >= 1) {
                const organization = organizationsList[0]
                state.selectedOrganization = organization
            }
        },
        removeSelectedOrganization: (state, action) => {
            state.selectedOrganization = null;
            state.isOrganizationInitialized = false;
        },
        resetOrganizationState: (state) => {
            state.selectedOrganization = null;
            state.organizations = [];
            state.isOrganizationInitialized = false;
        }
    }
})

export default messageSlice.reducer;
export const { addOrganization, saveBpmnDiagram, updateProcessModel, addProcessModel, deleteProcessModel, addOrganizations, addSelectedOrganization, selectDefaultOrganization, removeSelectedOrganization, resetOrganizationState } = messageSlice.actions;

